jQuery(document).ready(function($){
  $('.mMenu').on('click',function(){
    $('#site-header').toggleClass('navOpen');
    $('body').toggleClass('navOpenbody');

  });

    $('.sub-menu').hide();
    $("li:has(ul)").click(function(){

$('.sub-menu').hide();

    //$("ul",this).slideToggle();
    $("ul",this).toggle();

    });


    $(".langsel").click(function(){
        $(".languages_block").fadeToggle( "fast", "linear" );


            /*$(".langclose").click(function(){
              $(".languages_block").fadeToggle( "fast", "linear" );*/

    });


    $('a[href*="#"]').on('click', function (e) {
            e.preventDefault();
            $('html, body').animate({
                scrollTop: $($(this).attr('href')).offset().top - 50
            }, 500, 'linear');
        });


});
